// Layer body
const LayerBody = ({ className, ...restProps }) => {
  return <div className="mm-pod-layer-element-hgroup">{restProps.children}</div>;
};

export default LayerBody;
